import React from 'react'

function Tab({ children }) {
  return (
    <>{children}</>
  )
}

export default Tab